<template>
  <div v-if="loading" class="spinner-container">
    <div class="spinner"></div>
  </div>
  <div v-else>
    <!-- Keep-alive should wrap <router-view /> -->

    <div class="homepage d-flex flex-column vh-100">
      <!-- navbar -->
      <div class="homepage-navbar bg-light shadow mb-auto p-3 bg-primary">
        <div class="d-flex align-items-center">

          <span @click="goBack()" class="text-white"><i class="bi bi-arrow-left fs-5"></i></span> &nbsp; &nbsp;

          <span>
            <h4 class="text-white">{{ language?.all_order }}</h4>
          </span>

       

          <div class="d-flex align-items-center gap-2 ms-auto">

            <a href="#" class="link-dark text-truncate d-flex align-items-center gap-2" data-bs-toggle="offcanvas"
              data-bs-target="#orderDetailsCanvas" aria-controls="orderDetailsCanvas">
              <b class="bg-white   rounded-circle user-icon">
                <i class="bi bi-filter  d-flex m-1 h4 text-dark"></i>
              </b>
            </a>
          </div>

          
         
        </div>




      </div>

      <!-- body -->
      <div class="my-auto overflow-auto vh-100">
         <div class="container bg_card  ">

          <div class="  pt-2 row">
            <div class="col-12 pb-1">
              <input type="text" v-model="search_txt"  :placeholder="language?.search_cust"   class="form-control">
            </div>
            <div class="  border-1 overflow-hidden col-12" v-for="(order,i) in filteredorderList"
               >

               
                <div class="card card-body p-1">
                 <div class="text-muted">Bill NO. #{{order.billno}}  <span class="float-right">Date: {{order.billdate}}</span></div>
              <div  class="text-dark"> <strong>{{ order.cust_name }}</strong></div>
              <div class="text-muted">Delivery Date : {{order.deliverydate}}&nbsp;
              <!--<span :class="order.status=='completed'?'badge bg-success':(order.status=='New Order'?'badge bg-dark':'badge bg-warning text-dark')"  >{{order.status}}</span></div>-->
               <span :class="order.status=='completed'?'badge bg-success':(order.status=='New Order'?'badge bg-dark':(order.status=='delivered'?'badge bg-dark text-white':'badge bg-warning text-dark'))"  >{{order.status}}</span></div>
              <div class="row">
                <div class="col-4" style="color: black;">{{ language?.total }}</div>
                <div class="col-4" style="color: black;">{{ language?.paid }}</div>
                <div class="col-4" style="color: black;">{{ language?.due }}</div> 


                <div class="col-4" style="color: red;"> {{order.total}}</div>
                <div class="col-4" style="color: red;">  {{order.paidamt}}</div>
                <div class="col-4" style="color: red;">{{ order.total - order.paidamt }}</div>
            </div>  
            
              <div>
                <router-link :to="'/orderDetails?id='+order.id" >
                <span class="badge bg-success">
                  <i class="bi bi-eye"></i> &nbsp; View
                </span> &nbsp; &nbsp;
              </router-link>

              <!-- <router-link :to="'/orderlist?id='+order.custid" >
                <span class="badge bg-success">
                  <i class="bi bi-eye"></i> &nbsp; All Order
                </span>
              </router-link>-->
              
              </div> 

            </div> 
              
            </div>
         </div>
          </div>
             
 







      </div>
  
      <div class="offcanvas offcanvas-bottom custom_height border-0" tabindex="-1" id="orderDetailsCanvas"
      aria-labelledby="orderLabel">
      <div class="offcanvas-header bg-primary d-flex align-items-center justify-content-start gap-3">
        <a href="#" data-bs-dismiss="offcanvas" aria-label="Close"><i
            class="bi bi-arrow-left fs-5 text-white"></i></a>
        <h6 class="offcanvas-title text-white m-0" id="orderLabel">Filter</h6>
      </div>
      <div class="offcanvas-body">
          <div class="col-12 row">
              <div class="col-6">
                  <label for="address m-0 p-0" class="form-label">From Date</label>
                  <input type="date" id="" v-model="filter.fromdate" class="form-control m-0 p-0" >
                
              </div>
              <div class="col-6">
                  <label for="address m-0 p-0" class="form-label">To date</label>
                  <input type="date" id="" v-model="filter.todate" class="form-control m-0 p-0" >    
              </div>
              <div class="offcanvas-footer">
                <!--<button class="btn btn-success col-12" v-if="selected_services && selected_services.length>0" @click="confirmCosts">-->
                <button class="btn btn-success col-12"  @click="filterallorderlist">
                 <i class="bi bi-check"></i> &nbsp;Filter
               </button>
            </div>
  </div>
  </div>
          
    
    </div>
   


    
    </div>
  </div>
</template>
<style>
.float-right{
    float: right;
}
.bottom_border{
        border-bottom: 1px solid gray;
}
.footer_area{
        position: fixed;
        width: -webkit-fill-available;
        bottom: 0;
        background: aliceblue;
        padding: 5px 10px;
}
    .custom_height {
           min-height: 80vh;
        max-height: 80vh;
        overflow-y: auto;
    }
</style>
<script>
import axios from "@/plugins/axios";
import { reactive } from "vue";

  export default {
    name: 'Branch',
    components: {
    },
    
    
    mounted() {
      //  this.fetchWeather();
      if(this.$route.query.id){
      this.getNewOrderBasics(this.$route.query.id); // Call the method here
    }
    this.getNewOrderBasics();
   
    },
    watch: {
      search_txt(newVal) {
        this.filteredorderList = this.orderList.filter((item) =>
          (item.cust_name?item.cust_name.toLowerCase():'').includes(newVal.toLowerCase())
        );
      },
       
    },
    data() {
      return { 
        loading: false,
        error: null,
        isUserLogged: false,
        user_details: [],
        orderList: [],
        productsCostList: [],
        filteredproductsCostList: [],
        filteredorderList: [],
        selected: [],
        customers: [],
        language:this.getLocalStorageArray('lang'),
        selected_services: {},
        order_products_services: {},
        
        filter:{
          fromdate:new Date().toISOString().split('T')[0],
          todate:new Date().toISOString().split('T')[0],
        },

        customer:{
          name:'',
          contact:'',
          address:'',
        },

        
        search_txt: '',

      }
    },
    methods: {
      initializeHomeContent() {


      },
      editBranch(editBranch) {
         window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("branch")).show();
        //  this.branch=editBranch;
      },
      goBack() {
          
          this.$router.go(-1);
  },
             
      async getNewOrderBasics(custid="") {
        this.loading = true;
        this.error = null;

        try {
          var self = this;
          axios.post("getallorderlist",{custid:custid}).then((response) => {
            self.productsCostList = response.data.cost;
            self.servicesList = response.data.servicesLists;
            self.orderList = response.data.order_list;
            self.filteredorderList = self.orderList; 
            self.language=response.data.language;
            localStorage.setItem('lang',response.data.language);

          }).then(() => {
            self.initializeHomeContent();

            $("#customers").select2({
              width: '100%',
              placeholder: "Search Services Here...",
              "language": {
                "noResults": function () {
                  return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                }
              },
              escapeMarkup: function (markup) {
                return markup;
              }
            }).on('change', function (event) {
                self.order.cust_id= $(this).val(); 
                
            });
          }).catch((err) => {

          });;


        } catch (err) {
          this.error = err.response?.data?.message || "Login failed. Please try again.";
        } finally {
          this.loading = false;
        }
      },

 
  

      filterallorderlist() {
        this.loading = true;
        this.error = null;
  
        try {
           var self=this;
            axios.post("filterallorderlist",self.filter).then((response) => {
               
              self.orderList=response.data.order_list;
              self.filteredorderList = self.orderList; 
                       window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("orderDetailsCanvas")).hide();
                      

               
        
          }).then(() => {
               self.initializeHomeContent();
          }).catch((err) => {
            
          });;
         

        } catch (err) {
          this.error = err.response?.data?.message || "Login failed. Please try again.";
        } finally {
          this.loading = false;
        }
      }, 

      
      getLocalStorageArray(key) {
        let data = localStorage?.getItem(key);
        try {
            return data ? JSON.parse(data) : [];
        } catch (e) {
            console.error("Error parsing localStorage data", e);
            return [];
        }
    },







    }
  }






</script>